<script>
import Layout from '@layouts/main'

import formatDate, { dateDiffInMinutes } from '@utils/format-date'
import { authComputed } from '@state/helpers'
import { parseStringToDateTime } from '@utils/parse-string-to-date'
import ModalDeduct from '@components/ModalDeduct';
import ModalLogin from '@components/ModalLogin';

export default {
  page() {
    return {
      title: this.order.merchant.name,
    }
  },
  components: { Layout, ModalDeduct, ModalLogin },
  props: {
    order: {
      type: Object,
      required: true,
    },
    pageType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isDeductProcessing: false,
      isModalDeductActive: false,
      deductCallBack: null,
      isModalLoginActive: false,
      loginCallBack: null,
    }
  },
  computed: {
    ...authComputed,
    hasExtrafieldsBySize() {
      const customerInfos = this.order.customerInfos.length > 0 ? this.order.customerInfos : false;
      const orderExtrafields = customerInfos ? customerInfos[0].bySizeExtrafields : {};

      return Object.keys(orderExtrafields).length > 0;
    },
    hasExtrafieldsByOrder() {
      const orderExtrafields = this.order.byOrderExtrafields || {};

      return Object.keys(orderExtrafields).length > 0;
    },
    hasExtrafields() {
      return this.hasExtrafieldsBySize || this.hasExtrafieldsByOrder;
    },
    newebpayCallBack() {
      const callbackData = window.globalData.newebpay;
      return (
        callbackData &&
        callbackData.status !== '{{$status}}' && {
          isSuccess: callbackData.status === 'SUCCESS',
          isExpired: callbackData.status === 'EXPIRED',
          message: callbackData.message || '',
        }
      )
    },
    orderCallBack() {
      const callbackData = window.globalData.order;
      return (
        callbackData &&
        callbackData.status !== '{{$status}}' && {
          isSuccess: callbackData.status === 'SUCCESS',
          message: callbackData.type || '',
        }
      )
    },
    greetingNameWithTitle() {
      const genderTitleMap = {
        male: this.$t('global.GREETING_MALE_WITH_NAME' /* 先生 */, {
          name: this.order.fullName,
        }),
        female: this.$t('global.GREETING_FEMALE_WITH_NAME' /* 小姐 */, {
          name: this.order.fullName,
        }),
      }
      return genderTitleMap[this.order.gender]
    },
    /*
      - 0：已取消 isCancelOrder
      - 1：已付款 isPaidOrder
      - 2：未付款 isUnPaidOrder
      */
    isCancelOrder() {
      return this.order.status === 0
    },
    isPaidOrder() {
      return this.order.status === 1
    },
    isUnPaidOrder() {
      return this.order.status === 2
    },
    orderStatusClass() {
      const statusClassMap = {
        0: 'has-text-orange is-size-6',
        1: 'has-text-primary',
        2: 'has-text-danger is-size-6',
      };
      return statusClassMap[this.order.status]
    },
    orderStatus() {
      const status = {
        'cash': [
          this.$t('global.CANCELED' /* 已取消 */),
          this.$t('global.PAID' /* 已付款 */),
          this.$t('global.UNPAID' /* 未付款 */),
        ],
        'prepaid': [
          this.$t('global.CANCELED' /* 已取消 */),
          this.$t('global.DEDUCTED' /* 已抵用 */),
          this.$t('global.CONFIRMED' /* 待確認 */),
        ]
      };

      return status[this.order.prepaid && this.pageType === 'product' ? 'prepaid' : 'cash'][this.order.status]
    },
    orderTimeInterval() {
      const dateDiff = dateDiffInMinutes(this.order.startDate, this.order.endDate);

      if(dateDiff > 60 * 24 * 30) {
        return this.$tc('global.ABOUT_TIME_MOUTH', dateDiff / (60 * 24 * 30), { minute: Math.floor(dateDiff / (60 * 24 * 30)) }/* (預計{minute}個月) */)
      }else if(dateDiff > 60 * 24) {
        return this.$tc('global.ABOUT_TIME_DAY', dateDiff / (60 * 24), { minute: Math.floor(dateDiff / (60 * 24)) }/* (預計{minute}天) */)
      }else if(dateDiff > 60) {
        return this.$tc('global.ABOUT_TIME_HOUR', dateDiff / 60, { minute: Math.floor(dateDiff / 60) }/* (預計{minute}小時) */)
      }else {
        return this.$tc('global.ABOUT_TIME_MINUTE', dateDiff, { minute: Math.floor(dateDiff) }/* (預計{minute}分鐘) */)
      }
    },
    orderProductType() {
      if(this.pageType === 'prepaid') {
        return 'prepaid'
      }else {
        return this.order.productType || 'activity'
      }
    },
    isNullOrder() {
      return typeof this.order === 'object' && Object.keys(this.order).length === 0
    }
  },
  created() {
    this.$store.dispatch('booking/updateCart')
  },
  methods: {
    handleCancel() {
      const vnodes = [];

      if (this.order.merchant.email) {
        vnodes.push(
        <a href={`mailto:${this.order.merchant.email}`}>
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="far"
        data-icon="envelope"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
      class="svg-inline--fa fa-envelope fa-fw icon is-box fix-position is-left"
          >
          <path
        fill="currentColor"
        d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"
          ></path>
          </svg>
        {this.order.merchant.email}
      </a>
      )
      }

      if (this.order.merchant.phoneNumber) {
        vnodes.push(<br />)
        vnodes.push(
        <a href={`tel:${this.order.merchant.phoneNumber}`}>
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="fal"
        data-icon="mobile-android-alt"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 320 512"
      class="svg-inline--fa fa-mobile-android-alt fa-fw icon is-box fix-position is-left"
          >
          <path
        fill="currentColor"
        d="M224 96v240H96V96h128m48-96H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM48 480c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16v416c0 8.8-7.2 16-16 16H48zM244 64H76c-6.6 0-12 5.4-12 12v280c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12zm-48 352h-72c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h72c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12z"
          ></path>
          </svg>
        {this.order.merchant.phoneNumber}
      </a>
      )
      }
      const createElement = this.$createElement;
      const messageElement = createElement('p', null, vnodes);

      this.$alert(
        messageElement,
        this.$t(
          'global.LIGHT_BOX_CANCEL_RESERVATION_TITLE',
          {
            actionName: this.$t(
              `product.${this.orderProductType}.ORDER_CANCEL`
            ),
            merchantName: this.order.merchant.name,
          } /* 取消預訂請聯繫{merchantName} */
        ),
        {
          distinguishCancelAndClose: false,
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t(
            'global.LIGHT_BOX_CANCEL_RESERVATION_CONFIRM' /* 我瞭解了 */
          ),
          confirmButtonClass: 'button is-primary is-rounded',
        }
      )
    },
    reloadPage() {
      this.$router.go(0)
    },
    googleCalendarUrl(order) {
      // dates   時間格式為 YYYYMMDDTHHMMSS
      // details 使用 %0A 作為跳行
      const text = order.productName || '';
      const start = order.startDate
        .replace(/-/g, '')
        .replace(/:/g, '')
        .replace(/\s/g, 'T');
      const end = order.endDate
        .replace(/-/g, '')
        .replace(/:/g, '')
        .replace(/\s/g, 'T');
      const dates = `${start}/${end}`;
      const details = order.productDescription || '';
      const location = order.productAddress || '';
      const query = `action=TEMPLATE&text=${text}&dates=${dates}&details=${details}&location=${location}&trp=false`;

      return `http://www.google.com/calendar/event?${query}`
    },
    toOrder(orderId, hasData = true) {
      if(!this.loggedIn && this.orderCallBack) {
        this.isModalLoginActive = true;
        this.loginCallBack = () => {
          this.toOrder(orderId, hasData)
        };
        return false;
      }

      window.globalData.order = hasData ? {
        status: 'SUCCESS',
        type: 'deduct'
      } : false;

      if(hasData || (this.orderCallBack && Object.keys(this.orderCallBack).length > 0)) {
        this.reloadPage();
      }else {
        this.$router.push({
          name: this.pageType === 'prepaid' ? 'prepaid-order-detail' : 'order-detail',
          params: {
            orderKey: orderId
          },
          query: {
            o: this.$route.query.o ? undefined : orderId,
            language: this.$route.query.language,
          }
        })
      }
    },
    handleToBookingDeductUnpaid(order) {
      if(this.hasExtrafields) {
        this.$router.push({
          name: 'booking-unpaid-checkout',
          params: {
            merchantAlias: this.order.merchant.alias,
            productId: this.order.productAlias,
            orderKey: this.order.id,
          },
          query: {
            language: this.$route.query.language,
          },
        })
      }else {
        if(!this.loggedIn) {
          this.isModalDeductActive = true;
          this.deductCallBack = () => {
            this.toOrder(order.id)
          };
          return false;
        }

        this.isDeductProcessing = true;

        this.$store.dispatch('booking/fetchOrderDeduct', {
          orderKey: order.id
        })
          .then((response) => {
            this.toOrder(order.id)
          })
          .finally(() => {this.isDeductProcessing = false});
      }
    },
    handleToOrderItem() {
      if(!this.loggedIn) {
        this.isModalLoginActive = true;
        this.loginCallBack = () => {
          this.handleToOrderItem()
        };
        return false;
      }

      this.$router.push({
        name: 'member-order-item',
        params: {
          orderKey: this.order.id
        },
        query: {
          language: this.$route.query.language,
          merchant: this.order.merchant.alias
        }
      })

    },
    handleToPrepaidOrderItem() {
      if(!this.loggedIn) {
        this.isModalLoginActive = true;
        this.loginCallBack = () => {
          this.handleToPrepaidOrderItem()
        };
        return false;
      }

      this.$router.push({
        name: 'member-prepaid-item',
        params: {
          orderKey: this.order.id
        },
        query: {
          merchant: this.$route.query.merchant
        }
      })

    },
    toOrderApplicable() {
      if(!this.loggedIn) {
        this.isModalLoginActive = true;
        this.loginCallBack = () => {
          this.toOrderApplicable()
        };
        return false;
      }

      this.$router.push({
        name: 'member-prepaid-applicable',
        params: {
          orderKey: this.order.id
        },
        query: {
          merchant: this.$route.query.merchant
        }
      })
    },
    toPrepaidUnpaidCheckout() {
      /* if(!this.loggedIn) {
        this.isModalLoginActive = true;
        this.loginCallBack = () => {
          this.toPrepaidUnpaidCheckout()
        };
        return false;
      } */

      this.$router.push({
        name: 'booking-prepaid-unpaid-checkout',
        params: {
          merchantAlias: this.order.merchant.alias,
          prepaidId: this.order.prepaid.alias,
          orderKey: this.order.id,
        },
        query: {
          language: this.$route.query.language,
        },
      })
    },
    orderIsCanPay(order) {
      const isExpired = parseStringToDateTime(order.startDate) <= new Date();
      const isAllowExpired = order.allowExpired;

      return !isExpired || (isExpired && isAllowExpired)
    },
    formatDate,
  },
}
</script>

<template>
  <Layout>
    <template v-if="!isNullOrder">
      <div class="booking-container has-text-centered">
        <!--抵用-->
        <template v-if="orderCallBack && Object.keys(orderCallBack).length > 0">
          <div class="booking-section">
            <div class="subsection">
              <img alt="結帳成功" :class="$style.image" src="~@assets/images/3d_success.png" />
              <h1 class="has-text-primary is-size-3">{{ $t('global.DEDUCT_SUCCESS_TITLE'/*驗證成功 !*/) }}</h1>
              <p>{{ $t('global.CALLBACK_PRODUCT_CONTENT'/*感謝您的支持！您的驗證已完成。我們已寄發入場憑證致使用人的電子郵件*/) }}</p>
              <br>
              <br><br>
              <b-button
                type="is-primary"
                rounded
                class="is-fullwidth"
                @click="toOrder($route.params.orderKey, false)"
              >{{ $t(`product.${orderProductType}.BUTTON_GO_TO_DETAIL`/* 查看資訊 */)
                }}<span v-if="!loggedIn">({{ $t('global.NEED_LOGIN'/*需驗證*/) }})</span></b-button>
            </div>
          </div>
        </template>
        <!--藍新-->
        <template v-else-if="newebpayCallBack">
          <div class="booking-section">
            <div class="subsection">
              <template v-if="newebpayCallBack.isSuccess">
                <img alt="結帳成功" :class="$style.image" src="~@assets/images/3d_success.png" />
                <h1 class="has-text-primary is-size-3">{{ $t('global.CALLBACK_SUCCESS_TITLE'/*結帳成功*/) }}</h1>
                <p v-if="pageType === 'prepaid'">{{ $t('global.CALLBACK_PREPAID_CONTENT'/*感謝您的支持！您的驗證已完成。我們已寄發結帳成功信至您的電子郵件*/) }}</p>
                <p v-else>{{ $t('global.CALLBACK_PRODUCT_CONTENT'/*感謝您的支持！您的驗證已完成。我們已寄發入場憑證至使用人的電子郵件*/) }}</p>
                <br>
                <br><br>
                <b-button
                  type="is-primary"
                  rounded
                  class="is-fullwidth"
                  @click="toOrder($route.params.orderKey, false)"
                >{{ $t(`product.${orderProductType}.BUTTON_GO_TO_DETAIL`/* 查看資訊 */)
                  }}<span v-if="!loggedIn">({{ $t('global.NEED_LOGIN'/*需驗證*/) }})</span></b-button>
              </template>
              <template v-else-if="newebpayCallBack.isExpired">
                <img alt="結帳失敗" :class="$style.image" src="~@assets/images/3d_expired.png" />
                <h1 class="has-text-primary is-size-3">{{ $t('global.CALLBACK_EXPIRED_TITLE'/*逾時結帳，付款未成功*/) }}</h1>
                <p>{{ $t('global.CALLBACK_EXPIRED_CONTENT'/*親愛的客戶，您的訂單已逾時，造成結帳未成功，請您重新再試。提醒您，請在15分鐘內完成結帳，以免訂單逾時*/) }}</p>
              </template>
              <template v-else>
                <img :class="$style.image" src="~@assets/images/3d_failed.png" />
                <h1 class="has-text-primary is-size-3">{{ $t('global.CALLBACK_FAILED_TITLE'/*結帳失敗*/) }}</h1>
                <p>{{ newebpayCallBack.message }}</p>
              </template>
            </div>
          </div>
          <!--<div class="booking-section">
            <div class="subsection">
              <b-message
                :title="(newebpayCallBack.isSuccess) ? $t('global.PAYMENT_NEWEBPAY_SUCCESS'/* 付款成功 */)  : $t('global.PAYMENT_NEWEBPAY_FAIL'/* 付款失敗 */) "
                :type="(newebpayCallBack.isSuccess) ? 'is-primary' : 'is-danger'"
                :closable="false"
              >
                <template v-if="newebpayCallBack.isSuccess">
                  <img alt="結帳成功" :class="$style.image" src="~@assets/images/checkout_success.png" />
                  <b-button
                    type="is-primary"
                    rounded
                    @click="reloadPage"
                  >{{ $t(`product.${orderProductType}.BUTTON_GO_TO_DETAIL`/* 查看資訊 */) }}</b-button>
                </template>
                <template v-else>
                  <img :class="$style.image" src="~@assets/images/checkout_fail.png" />
                  <p class="has-text-centered">{{ newebpayCallBack.message }}</p>
                </template>
              </b-message>
            </div>
          </div>-->
        </template>
        <!--正常-->
        <template v-else>
          <div class="booking-section--outside">
            <div
              class="is-size-5 has-text-grey-dark has-text-weight-medium"
            >{{ order.gender ? greetingNameWithTitle : order.fullName }}</div>
            <div
              class="has-text-grey-light has-text-weight-medium"
            >{{ $t(`product.${orderProductType}.ORDER_DETAILS`/* 以下是您的預訂資訊 */) }}</div>
          </div>
          <div class="booking-section">
            <div class="subsection">
              <!--預付方案-->
              <div v-if="pageType === 'prepaid'" class="subsection__inner">
                <!--<h4 class="order-datetime__name">{{ order.productName }}</h4>-->
                <div class="order-datetime">
                  <div class="has-text-primary is-size-4" style="margin-bottom: 1rem">{{order.prepaid.title}}</div>
                  <div class="has-text-grey-light is-size-6" style="margin-bottom: 6rem">{{order.merchant.name}}</div>
                </div>
                <div :class="$style['paramsList']">
                  <div
                    :class="$style['paramsList__item']"
                  >
                    <div>
                      <span class="has-text-grey-light param-multiplier">x</span>
                      <span class="has-text-weight-medium">1</span>
                    </div>
                    <div class="has-text-grey-light">
                      <span class=" is-size-7 has-text-grey" style="margin-right: 0.5rem">{{$t('global.PREPAID_TOTAL_QUOTA' /*方案可使用額度*/)}}</span>
                      <span class="is-size-6 has-text-grey-dark has-text-weight-medium">{{order.times}}</span>
                    </div>
                  </div>
                </div>
                <div :class="$style['paramsList__total']">
                  <div :class="$style['paramsList__item']" style="margin-bottom: 2rem">
                    <div>
                      <span class="has-text-weight-medium">{{ $t('global.TOTAL'/* 總計 */) }}</span>
                    </div>
                    <div class="has-text-grey-light">
                      $ {{ order.price }}
                    </div>
                  </div>
                  <div :class="$style['paramsList__item']">
                    <div class="has-text-left">
                      <span class="has-text-weight-medium" :class="orderStatusClass">{{orderStatus}}</span>
                      <div v-if="isPaidOrder" class="is-size-7 has-text-grey-light">
                      <span>
                        {{ $t(`global.PAYMENT_METHOD_ORDER_${order.paymentMethod.toUpperCase()}`,
                        { date: formatDate(order.paidDate, 'dateWeekDay') }/* 信用卡付款 {date} */) }}
                      </span>
                      </div>
                      <div v-if="isUnPaidOrder && pageType !== 'prepaid'" class="is-size-7 has-text-danger">
                        <template v-if="orderIsCanPay(order) && order.allowExpired === 0">
                          {{ $t('global.PAYMENT_DATE_UNPAID',
                          { date: formatDate(order.startDate, 'dateWeekDay') }/* 請於 {date} 前完成付款 */) }}
                        </template>
                        <template v-else-if="order.allowExpired === 0">{{ $t('global.PAYMENT_DATE_EXPIRED' /*已超過付款期限*/)
                          }}</template>
                      </div>
                      <div v-if="isCancelOrder" class="is-size-7 has-text-grey-light">
                        {{ $t('global.PAYMENT_DATE_CANCELED',
                        { date: formatDate(order.cancelDate, 'dateWeekDay') }/* 於 {date} 取消 */) }}
                      </div>
                    </div>
                    <div
                      class="order-datetime__total is-size-4"
                      :class="isCancelOrder ? 'has-text-grey-light' : 'has-text-primary'"
                    >
                      <span v-if="order.prepaid.basePrice > order.price" :class="$style['basePrice']" class="has-text-grey-light">原價 ${{Math.floor(order.prepaid.basePrice)}}</span>
                      $ {{ order.price }}</div>
                  </div>
                </div>
              </div>
              <!--活動-->
              <div v-else class="subsection__inner">
                <h4 class="order-datetime__name">{{ order.productName }}</h4>
                <div class="order-datetime">
                  <div class="order-datetime__date">{{ formatDate(order.startDate ,'dateWeekDay')}}</div>
                  <div
                    class="order-datetime__time"
                    :class="isCancelOrder ? 'has-text-grey-light' : 'has-text-accent'"
                  >
                    {{ formatDate(order.startDate ,'time')}}
                    <h5 class="is-size-6 has-text-grey">{{orderTimeInterval}}</h5>
                  </div>
                </div>
                <div :class="$style['paramsList']">
                  <div
                    v-for="(param) in order.params"
                    :key="param.name"
                    :class="$style['paramsList__item']"
                  >
                    <div>
                      <span class="has-text-weight-medium">{{ param.qty }}</span>
                      <span class="has-text-grey-light param-multiplier">x</span>
                      {{ param.name }}
                    </div>

                    <div class="has-text-grey-light">
                      {{ param.size * param.qty }}
                      <BaseIcon name="ticket-alt" />
                    </div>
                  </div>
                </div>
                <div :class="$style['paramsList__total']">
                  <div :class="$style['paramsList__item']">
                    <div>
                      <span class="has-text-weight-medium">{{ $t('global.TOTAL'/* 總計 */) }}</span>
                    </div>
                    <div class="has-text-grey-light">
                      {{ order.groupSize }}
                      <BaseIcon name="ticket-alt" />
                    </div>
                  </div>
                  <div class="level has-text-left">
                    <div class="level-left">
                      <div>
                        <div class="has-text-weight-medium" :class="orderStatusClass">{{orderStatus}}</div>
                        <div v-if="isPaidOrder" class="is-size-7 has-text-grey-light">
                      <span>
                        {{ $t(`global.PAYMENT_METHOD_ORDER_${order.paymentMethod.toUpperCase()}`,
                        { date: formatDate(order.paidDate, 'dateWeekDay') }/* 信用卡付款 {date} */) }}
                      </span>
                        </div>
                        <div v-if="isUnPaidOrder" class="is-size-7 has-text-danger">
                          <template v-if="orderIsCanPay(order) && order.allowExpired === 0">
                            {{ $t('global.PAYMENT_DATE_UNPAID',
                            { date: formatDate(order.startDate, 'dateWeekDay') }/* 請於 {date} 前完成付款 */) }}
                          </template>
                          <template v-else-if="order.allowExpired === 0">{{ $t('global.PAYMENT_DATE_EXPIRED' /*已超過付款期限*/)}}</template>
                        </div>
                        <div v-if="isCancelOrder" class="is-size-7 has-text-grey-light">
                          {{ $t('global.PAYMENT_DATE_CANCELED',
                          { date: formatDate(order.cancelDate, 'dateWeekDay') }/* 於 {date} 取消 */) }}
                        </div>
                      </div>
                      <!--<div v-if="order.paymentMethod === 'prepaid'" :class="isUnPaidOrder ? 'has-text-danger' :
                      'has-text-grey-light'" class="is-size-7">
                        使用方案 {{order.prepaid.title}}
                      </div>-->
                    </div>
                    <div
                      v-if="order.paymentMethod === 'prepaid'"
                      class="level-right is-size-5 has-text-right"
                      :class="isCancelOrder ? 'has-text-grey-light' : 'has-text-primary'"
                    >
                      {{ $t('global.TOTAL_DEDUCT', { size: order.prepaid.deductTimes } /* 抵用 {size} 次 */) }}
                    </div>
                    <div
                      v-else
                      class="level-right is-size-4 has-text-right"
                      :class="isCancelOrder ? 'has-text-grey-light' : 'has-text-primary'"
                    >${{ order.priceTotal }}</div>
                  </div>
                </div>
              </div>
            </div>
            <!--預付方案-->
            <template v-if="pageType === 'prepaid'">
              <div v-if="isPaidOrder" class="subsection">
                <div class="buttons">
                  <b-button
                    type="is-primary"
                    rounded
                    class="is-fullwidth"
                    @click="toOrderApplicable"
                  >{{ $t('global.MEMBER_ORDER_VIEW_APPLICABLE'/*查看適用項目*/) }}</b-button>
                  <b-button
                    type="is-black"
                    outlined
                    rounded
                    class="is-fullwidth"
                    @click="handleToPrepaidOrderItem"
                  >{{ $t('global.MEMBER_ORDER_VIEW_DETAIL'/*查看訂單詳情*/) }}<span v-if="!loggedIn">({{ $t('global.NEED_LOGIN'/*需驗證*/) }})</span></b-button>
                  <!--<p class="has-text-centered has-text-grey-light" style="width: 100%">({{ $t('global.ORDER_CANCEL_TIP'/*活動開始前3日內取消恕不退款*/) }})</p>-->
                  <b-button
                    type="is-black"
                    outlined
                    rounded
                    class="is-fullwidth"
                    @click="handleCancel"
                  >{{ $t(`product.${orderProductType}.ORDER_CANCEL`/* 取消預訂 */) }}</b-button>
                </div>
              </div>
              <div v-else-if="isUnPaidOrder" class="subsection">
                <div class="buttons">
                  <b-button
                    rounded
                    type="is-primary"
                    class="is-fullwidth"
                    @click="toPrepaidUnpaidCheckout">
                    {{ $t('global.PAYMENT_NOW'/* 前往付款 */) }}
                  </b-button>
                  <!--<p class="has-text-centered has-text-grey-light" style="width: 100%">({{ $t('global.ORDER_CANCEL_TIP'/*活動開始前3日內取消恕不退款*/) }})</p>-->
                  <b-button
                    type="is-black"
                    outlined
                    rounded
                    class="is-fullwidth"
                    @click="handleCancel"
                  >{{ $t(`product.${orderProductType}.ORDER_CANCEL`/* 取消預訂 */) }}</b-button>
                </div>
              </div>
              <div v-else-if="isCancelOrder" class="subsection">
                <div class="buttons">
                  <router-link
                    class="button is-black is-rounded is-outlined is-fullwidth"
                    :to="{
                    name: 'booking-prepaid-item',
                    params: {
                      merchantAlias: order.merchant.alias,
                      prepaidAlias: order.prepaid.alias,
                    },
                    query: {
                      language: $route.query.language,
                    },
                  }"
                  >
                    {{ $t(`product.${orderProductType}.BUTTON_GO_TO_DETAIL`/* 查看資訊 */) }}
                  </router-link>
                </div>
              </div>
            </template>
            <!--活動-->
            <template v-else>
              <div v-if="isPaidOrder" class="subsection">
                <div class="buttons">
                  <router-link
                    class="button is-primary is-rounded is-fullwidth"
                    :to="{
                    name: 'order-tickets',
                    params: {
                      orderKey: order.id,
                    },
                    query: {
                      language: $route.query.language,
                    },
                  }"
                  >
                    {{ $t('global.ADMISSION_QRCODE'/* 使用 QR Code */) }}
                  </router-link>
                  <a
                    target="_blank"
                    :href="googleCalendarUrl(order)"
                    class="button is-rounded is-outlined is-fullwidth is-primary"
                  >{{ $t('global.ADD_CALENDAR'/* 加入行事曆 */) }}</a>
                  <b-button
                    type="is-black"
                    outlined
                    rounded
                    class="is-fullwidth"
                    @click="handleToOrderItem"
                  >{{ $t('global.MEMBER_ORDER_VIEW_DETAIL'/*查看訂單詳情*/) }}<span v-if="!loggedIn">({{ $t('global.NEED_LOGIN'/*需驗證*/) }})</span></b-button>
                  <!--<p class="has-text-centered has-text-grey-light" style="width: 100%">({{ $t('global.ORDER_CANCEL_TIP'/*活動開始前3日內取消恕不退款*/) }})</p>-->
                  <b-button
                    type="is-black"
                    outlined
                    rounded
                    class="is-fullwidth"
                    @click="handleCancel"
                  >{{ $t(`product.${orderProductType}.ORDER_CANCEL`/* 取消預訂 */) }}</b-button>
                </div>
              </div>
              <div v-else-if="isUnPaidOrder" class="subsection">
                <div class="buttons">
                  <template v-if="order.prepaid">
                    <b-button
                      v-if="orderIsCanPay(order)"
                      type="is-primary"
                      rounded
                      class="is-fullwidth"
                      :loading="isDeductProcessing"
                      @click="handleToBookingDeductUnpaid(order)"
                    >{{ $t('global.CONFIRMED_DEDUCT'/*確認抵用*/) }}</b-button>
                  </template>
                  <template v-else>
                    <router-link
                      v-if="orderIsCanPay(order)"
                      class="button is-primary is-rounded is-fullwidth"
                      :to="{
                      name: 'booking-unpaid-checkout',
                      params: {
                        merchantAlias: order.merchant.alias,
                        productId: order.productAlias,
                        orderKey: order.id,
                      },
                      query: {
                        language: $route.query.language,
                      },
                    }"
                    >
                      {{ $t('global.PAYMENT_NOW'/* 前往付款 */) }}
                    </router-link>
                  </template>
                  <!--<p class="has-text-centered has-text-grey-light" style="width: 100%">({{ $t('global.ORDER_CANCEL_TIP'/*活動開始前3日內取消恕不退款*/) }})</p>-->
                  <b-button
                    type="is-black"
                    outlined
                    rounded
                    class="is-fullwidth"
                    @click="handleCancel"
                  >{{ $t(`product.${orderProductType}.ORDER_CANCEL`/* 取消預訂 */) }}</b-button>
                </div>
              </div>
              <div v-else-if="isCancelOrder" class="subsection">
                <div class="buttons">
                  <router-link
                    class="button is-black is-rounded is-outlined is-fullwidth"
                    :to="{
                    name: 'booking-product',
                    params: {
                      merchantAlias: order.merchant.alias,
                      productId: order.productAlias,
                    },
                    query: {
                      language: $route.query.language,
                    },
                  }"
                  >
                    {{ $t(`product.${orderProductType}.BUTTON_GO_TO_DETAIL`/* 查看資訊 */) }}
                  </router-link>
                </div>
              </div>
            </template>
          </div>
          <div v-if="!isCancelOrder" class="booking-section--outside">
            <router-link
              v-if="pageType === 'prepaid'"
              class="button is-black is-rounded is-outlined is-fullwidth"
              :to="{
              name: 'booking-prepaid-item',
              params: {
                merchantAlias: order.merchant.alias,
                prepaidAlias: order.prepaid.alias,
              },
              query: {
                language: $route.query.language,
              },
            }"
            >
              {{ $t(`product.${orderProductType}.BUTTON_GO_TO_DETAIL`/* 查看資訊 */) }}
            </router-link>
            <router-link
              v-else
              class="button is-black is-rounded is-outlined is-fullwidth"
              :to="{
              name: 'booking-product',
              params: {
                merchantAlias: order.merchant.alias,
                productId: order.productAlias,
              },
              query: {
                language: $route.query.language,
              },
            }"
            >
              {{ $t(`product.${orderProductType}.BUTTON_GO_TO_DETAIL`/* 查看資訊 */) }}
            </router-link>
          </div>
        </template>
      </div>
      <b-modal
        :active.sync="isModalDeductActive"
        :width="370"
        :can-cancel="['escape','outside']">
        <ModalDeduct :order="order" @close="isModalDeductActive = false" @login="deductCallBack"/>
      </b-modal>
      <b-modal
        custom-class="is-login-style"
        :active.sync="isModalLoginActive"
        :width="370"
        :can-cancel="['escape','outside']">
        <ModalLogin @close="isModalLoginActive = false" @login="loginCallBack"/>
      </b-modal>
    </template>
    <template v-else>
      <div class="booking-container">
        <div class="defaultBox">
          <img alt="merchant default" class="defaultBox__image" src="@assets/images/information_default.png" />
          <h1 class="defaultBox__text">
            {{$t('global.NOT_FOUND_PREFIX', { text: $t('global.ORDER') } /*找不到訂單*/)}}
          </h1>
        </div>
      </div>
    </template>
  </Layout>
</template>

<style lang="scss" module>
.image {
  align-self: center;
}

.paramsList {
  width: 18rem;
  max-width: 80vw;
  margin: 1rem auto;
  border-bottom: 1px dashed #53c2cc;
  &__item {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    padding-bottom: 0.75rem;
    position: relative;
  }
}
.cancelHelp {
  width: 100%;
}
.basePrice {
  position: absolute;
  top: -4px;
  right: 0;
  font-size: 12px;
  text-decoration: line-through;
}
</style>
